// extracted by mini-css-extract-plugin
export default {"confirmation-wrapper":"ConfirmationWrapper_confirmation-wrapper__h4wjF"};